var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileverX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_268",
    "data-name": "\\uADF8\\uB8F9 268",
    transform: "translate(-363 -43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_128",
    "data-name": "\\uADF8\\uB8F9 128",
    transform: "translate(42.858 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_61",
    "data-name": "\\uC0AC\\uAC01\\uD615 61",
    transform: "translate(320.142 62)",
    fill: "#fff",
    stroke: "#43434b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_135",
    "data-name": "\\uADF8\\uB8F9 135",
    transform: "translate(3414.636 -2740.364)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_68",
    "data-name": "\\uC120 68",
    x2: 22.729,
    y2: 22.729,
    transform: "translate(-3040.5 2794.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_69",
    "data-name": "\\uC120 69",
    x1: 22.729,
    y2: 22.729,
    transform: "translate(-3040.5 2794.5)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileverX);
export default __webpack_public_path__ + "static/media/mobilever_x.e143667813193de4b067a9c8bb10948f.svg";
export { ForwardRef as ReactComponent };